import _sfc_main from './IdfButton.vue2.mjs';
import '../../IdfButton.vue_vue_type_style_index_0_scoped_8e6ae260_lang.css';import _export_sfc from '../../_virtual/_plugin-vue_export-helper.mjs';

const IdfButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-8e6ae260"]]);

export { IdfButton as default };
